import ActiveItemsCard from "../ActiveItemsCard";
import { useIsSupportUser } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { EmptyCard } from "./EmptyCard";

type ActiveCostAnomaliesCardProps = {
  numberOfAnomalies: number;
  numberOfAnomaliesInLast30Days: number;
  loading: boolean;
  anomaliesAtRisk: number;
};

export const ActiveCostAnomaliesCard = ({
  numberOfAnomalies,
  numberOfAnomaliesInLast30Days,
  loading,
  anomaliesAtRisk,
}: ActiveCostAnomaliesCardProps) => {
  const isSupportUser = useIsSupportUser();

  if (loading) {
    return <LoadingCard title="Active anomalies" />;
  }

  if (anomaliesAtRisk === 0 || !anomaliesAtRisk) {
    return <EmptyCard title="Active cost anomalies" />;
  }

  return (
    <ActiveItemsCard
      title="Active anomalies"
      value={numberOfAnomalies}
      cloudCostsAtRisk={anomaliesAtRisk}
      dataIcon="trending up"
      trend={numberOfAnomaliesInLast30Days ?? 0}
      trendColor="error.main"
      trendDate="30 days"
      buttonLink="./monitor/cost-anomalies"
      riskLabel="Current costs at risk"
      disabled={isSupportUser}
      trackingEvent="Active Cost Anomalies"
      trackingDescription="Review and Take Action button for cost anomalies"
    />
  );
};
